import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import profileReducer from './slices/profileSlice';
import userReducer from './slices/userSlice';
import clientReducer from './slices/clientSlice';
import branchReducer from './slices/branchSlice';
import cityReducer from './slices/citySlice';
import jobApplicantReducer from './slices/jobApplicantSlice';
import jobPostingReducer from './slices/jobPostingSlice';
import consignmentReducer from './slices/consignmentSlice';
import vehicleReducer from './slices/vehicleSlice';
import riderReducer from './slices/riderSlice';
import trackingReducer from './slices/trackingSlice';
import jobsReducer from './slices/jobsSlice';
import contactReducer from './slices/contactSlice';
import dashboardReducer from './slices/dashboardSlice';
import financeLedgerReducer from './slices/financeLedgerSlice';
import financePaymentsReducer from './slices/financePaymentsSlice';
import financeNotesReducer from './slices/financeNotesSlice';
import financeInvoicesReducer from './slices/financeInvoicesSlice';
import branchFinanceReducer from './slices/branchFinanceSlice';
import branchCodReceiptsReducer from './slices/branchCodReceiptsSlice';
import branchDepositSlipsReducer from './slices/branchDepositSlipsSlice';
import settingsReducer from './slices/settingsSlice';
import headOfficeFinanceReducer from './slices/headOfficeFinanceSlice';
import adminReducer from './slices/adminSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        profile: profileReducer,
        users: userReducer,
        clients: clientReducer,
        branches: branchReducer,
        cities: cityReducer,
        jobApplicants: jobApplicantReducer,
        jobPostings: jobPostingReducer,
        consignments: consignmentReducer,
        vehicles: vehicleReducer,
        riders: riderReducer,
        tracking: trackingReducer,
        jobs: jobsReducer,
        contact: contactReducer,
        dashboard: dashboardReducer,
        financeLedger: financeLedgerReducer,
        financePayments: financePaymentsReducer,
        financeNotes: financeNotesReducer,
        financeInvoices: financeInvoicesReducer,
        branchFinance: branchFinanceReducer,
        branchCodReceipts: branchCodReceiptsReducer,
        branchDepositSlips: branchDepositSlipsReducer,
        settings: settingsReducer,
        headOfficeFinance: headOfficeFinanceReducer,
        admin: adminReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST'],
            },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 